import React from "react";

// @material-ui/core components
//import { makeStyles } from "@material-ui/core/styles";
// @material-ui/icons

// core components
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
//import Button from "components/CustomButtons/Button.js";
import Card from "components/Card/Card.js";
import CardBody from "components/Card/CardBody.js";

// import { cardTitle } from "assets/jss/material-dashboard-pro-react.js";

// import stylesAlert from "assets/jss/material-dashboard-pro-react/views/sweetAlertStyle.js";

// import stylesModal from "assets/jss/material-dashboard-pro-react/views/notificationsStyle.js";
// import stylesCheckbox from "assets/jss/material-dashboard-pro-react/views/regularFormsStyle";

import PropTypes from "prop-types";

import axios from "axios";

import { CSVLink } from "react-csv";

//import { ContactsOutlined } from "@material-ui/icons";

// const stylesCard = {
//   cardIconTitle: {
//     ...cardTitle,
//     marginTop: "15px",
//     marginBottom: "0px",
//   },
// };

// const stylesList = {
//   list: {
//     display: "inline",
//     padding: "5px",
//   },
// };

// const useStylesCheckbox = makeStyles(stylesCheckbox);

// const useStylesAlert = makeStyles(stylesAlert);

// const useStylesModal = makeStyles(stylesModal);

// const useStylesCard = makeStyles(stylesCard);

// const useStylesList = makeStyles(stylesList);

axios.defaults.withCredentials = true;

//const { REACT_APP_SERVER_URL } = process.env;

export default function DataExport(props) {
  // const classesAlert = useStylesAlert();
  // const classesModal = useStylesModal();
  // const classesCard = useStylesCard();
  // const classesList = useStylesList();
  // const classesCheckbox = useStylesCheckbox();

  /*  const classes = {
    ...classesAlert,
    ...classesModal,
    ...classesCard,
    ...classesList,
    ...classesCheckbox,
  }; */

  console.log(props);

  const membersData = props.members;
  const registrationsData = props.registrations || [];

  const csvMembersData = [
    ["name", "email", "institution"],
    ...membersData.map(({ name, email, institution }) => [
      name,
      email,
      institution,
    ]),
  ];

  const csvRegistrationsData = [
    [
      "name",
      "email",
      "institution",
      "conference_name",
      "role",
      "registration_type",
      "affiliation",
      "need_time",
      "agenda_topic",
      "agenda_time",
    ],
    ...registrationsData.map(
      ({
        name,
        email,
        institution,
        conference_name,
        role,
        registration_type,
        affiliation,
        need_time,
        agenda_topic,
        agenda_time,
      }) => [
        name,
        email,
        institution,
        conference_name,
        role,
        registration_type,
        Array.isArray(affiliation) ? affiliation.join("; ") : affiliation || "",
        need_time ? "Yes" : "No",
        agenda_topic || "",
        agenda_time || "",
      ],
    ),
  ];

  // const handleLoadButtonClick = () => {
  //   console.log(grantData);
  //   console.log(csvGrantData);
  // };

  return (
    <div>
      <GridContainer>
        <GridItem xs={12}>
          <Card>
            <CardBody>
              <h4 style={{ marginTop: 0, marginBottom: "20px" }}>
                Data Export
              </h4>
              <ul style={{ listStyleType: "disc", paddingLeft: "20px" }}>
                <li style={{ marginBottom: "15px" }}>
                  <CSVLink
                    className="downloadbtn"
                    filename="preventMembers.csv"
                    data={csvMembersData}
                    style={{
                      textDecoration: "none",
                    }}
                  >
                    Download Members
                  </CSVLink>
                </li>
                <li>
                  <CSVLink
                    className="downloadbtn"
                    filename="preventRegistrations.csv"
                    data={csvRegistrationsData}
                    style={{
                      textDecoration: "none",
                    }}
                  >
                    Download Conference Registrations
                  </CSVLink>
                </li>
              </ul>
            </CardBody>
          </Card>
        </GridItem>
      </GridContainer>
    </div>
  );
}

DataExport.propTypes = {
  members: PropTypes.array,
  registrations: PropTypes.array,
};
